import { render, staticRenderFns } from "./Pin.vue?vue&type=template&id=59c1b0e2&lang=pug"
import script from "./Pin.vue?vue&type=script&lang=js"
export * from "./Pin.vue?vue&type=script&lang=js"
import style0 from "./Pin.vue?vue&type=style&index=0&id=59c1b0e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports